import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	gotIt: {
		id: 'proforma-request-type-config.form-empty-state.changeboarding-spotlight.got-it',
		defaultMessage: 'Got it',
		description: 'Proforma RTC empty state changeboarding spotlight button text.',
	},
	text: {
		id: 'proforma-request-type-config.form-empty-state.changeboarding-spotlight.text',
		defaultMessage:
			'Easily add an existing form directly to your request type without leaving this page.',
		description: 'Proforma RTC empty state changeboarding spotlight text',
	},
	title: {
		id: 'proforma-request-type-config.form-empty-state.changeboarding-spotlight.title',
		defaultMessage: 'Add more customization to a request form',
		description: 'Proforma RTC empty state changeboarding spotlight title',
	},
	message: {
		id: 'proforma-request-type-config.form-empty-state.changeboarding-spotlight.message',
		defaultMessage:
			'Attach forms with advanced formatting including conditional sections, rich text, and form-only fields.',
		description: 'Proforma RTC empty state changeboarding spotlight text',
	},
});

export default messages;
